// Right-side panel shown on the blank state at the lg+ breakpoint.
// Per DESIGN §3.1: "How this works" + "What's covered" + privacy note.
// Hidden below lg via CSS. The empty-state main column stays usable on its own.

export function BlankInfoPanel() {
  return (
    <aside className="info-panel info-panel--blank" aria-label="About this tool">
      <section className="info-panel-section">
        <h2 className="info-panel-heading">How this works</h2>
        <ol className="info-panel-steps">
          <li>Ask a plain-language question about HRSA data.</li>
          <li>The assistant calls the right HRSA tools and APIs in parallel.</li>
          <li>You get a synthesized answer with sources you can verify.</li>
        </ol>
      </section>
      <section className="info-panel-section">
        <h2 className="info-panel-heading">What's covered</h2>
        <ul className="info-panel-list">
          <li>Health Centers (HRSA-funded)</li>
          <li>HPSA &amp; MUA designations</li>
          <li>HRSA Grants</li>
          <li>Ryan White HIV/AIDS Care</li>
          <li>National Health Service Corps sites</li>
          <li>Workforce shortage areas</li>
          <li>Congressional district info</li>
          <li>HRSA Fact Sheets &amp; Reports</li>
        </ul>
      </section>
      <section className="info-panel-section info-panel-section--privacy">
        <h2 className="info-panel-heading">
          <span aria-hidden="true">🔒</span> Privacy
        </h2>
        <p>
          Anonymous. Nothing is saved between visits. No sign-in required.
          Refreshing the page clears the conversation.
        </p>
      </section>
    </aside>
  );
}
